module.exports = __webpack_public_path__ + "static/media/_period.4a86cfa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_period.jpg
// module id = 51
// module chunks = 0